import {
    URLAPI,
    FINDINGS_MATRIX_PATH,
    FINDING_MATRIX_CREATE_PATH,
    FINDING_MATRIX_UPDATE_PATH,
} from "../config/index";
import {LOGOUT} from './users'
import axios from "axios";

const init = {
    _get_all_findings_matrix: {
        data: [],
        status: 0,
        message: {},
    },
    _create_finding_matrix: {
        data: {},
        status: 0,
        message: {},
    },
    _update_finding_matrix: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_FINDINGS_MATRIX = "GET_ALL_FINDINGS_MATRIX";
export const CREATE_FINDING_MATRIX = "CREATE_FINDING_MATRIX";
export const UPDATE_FINDING_MATRIX = "UPDATE_FINDING_MATRIX";

export const findings_matrix_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_FINDINGS_MATRIX:
            return {
                ...state,
                _get_all_findings_matrix: action.payload,
            };
        case CREATE_FINDING_MATRIX:
            return {
                ...state,
                _create_finding_matrix: action.payload,
            };
        case UPDATE_FINDING_MATRIX:
            return {
                ...state,
                _update_finding_matrix: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllFindingsMatrix = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${FINDINGS_MATRIX_PATH}`, {
            headers: {
                Authorization: `Basic ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_FINDINGS_MATRIX,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_FINDINGS_MATRIX,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_FINDINGS_MATRIX,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const createFindingMatrix = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${FINDING_MATRIX_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_FINDING_MATRIX,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_FINDING_MATRIX,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_FINDING_MATRIX,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateFindingMatrix = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${FINDING_MATRIX_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_FINDING_MATRIX,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_FINDING_MATRIX,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_FINDING_MATRIX,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_finding_matrix = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
